// extracted by mini-css-extract-plugin
export default {"container":"GanttBar_container__IphyR","textBase":"GanttBar_textBase__MsnZq","flightNo":"GanttBar_flightNo__U7qkn","arrival":"GanttBar_arrival__YLN4H"};